import { lazy } from 'react';

export const ViewsEntry = lazy(
  () => import(/* webpackChunkName: 'views' */ './ViewPage.tsx'),
);
